import {Link} from "react-router-dom";
import ServiceCard from "../components/ui/ServiceCard";
import About from "../components/About";
import WhyWeCard from "../components/ui/WhyWeCard";
import MessageForm from "../components/MessageForm";

export default function HomePage() {

    return <>
        <section className="relative bg-cover bg-center bg-no-repeat text-white"
                 style={{backgroundImage: "url('/img/background.jpg')"}}>
            <div className="absolute inset-0 bg-gradient-to-r from-[#1C3353] to-transparent"></div>

            <div
                className="relative max-w-6xl mx-auto px-6 py-8 md:py-8 flex flex-col items-center text-center space-y-4">
                <h1 className="text-lg md:text-3xl font-bold drop-shadow-lg">
                    Accounting and Tax Services for Individuals and Businesses
                </h1>
                <p>
                    Professional, accurate and compliant tax and accounting services, tailored to your needs.
                </p>

                <div className="flex flex-wrap justify-center gap-3">
                    <Link to="/intake"
                       className="w-60 inline-block bg-gradient-to-b from-[#F6D28B] to-[#F1C169] text-[#1C3353] text-[17px] font-semibold px-5 py-2 rounded-lg shadow-md shadow-yellow-600/20 whitespace-nowrap select-none transition-all duration-200 hover:from-[#F8DFA3] hover:to-[#F3C879] hover:shadow-lg hover:shadow-yellow-500/30 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-yellow-300">
                        Personal Tax Intake Form
                    </Link>
                    <Link to="/businessIntake"
                          className="w-60 inline-block bg-gradient-to-b from-[#ECECF1] to-[#DADAE0] text-[#1C3353] text-[17px] font-semibold px-5 py-2 rounded-lg shadow-md shadow-slate-400/20 whitespace-nowrap select-none transition-all duration-200 hover:from-[#F4F4F8] hover:to-[#DCDCE3] hover:shadow-lg hover:shadow-slate-400/30 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-slate-300">
                        Business Intake Form
                    </Link>
                </div>

            </div>
        </section>

        <About/>

        <section id="services" className="m-5 p-5 bg-white rounded-xl shadow-lg scroll-mt-24">
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Our Services</h2>

            <div className="flex flex-wrap justify-center gap-5">

                <ServiceCard title="Accounting & Financial Reporting" img="img/accounting_icon.png"
                             href="/services#accounting">
                    Financial reporting, compilation engagements, bookkeeping, GST/HST and PST filings
                </ServiceCard>

                <ServiceCard title="Tax Preparation & Tax Planning" img="img/tax_prep.png" href="/services#tax">
                    Personal and corporate tax services, tax planning and compliance
                </ServiceCard>

                <ServiceCard title="Payroll Services" img="img/payroll.png" href="/services#payroll">
                    Payroll processing, source deductions and remittances, and WCB reporting
                </ServiceCard>

                <ServiceCard title="Business Advisory & Planning" img="img/corporate_icon.png" href="/services#advisory">
                    Business plans, budgeting and forecasting, financial analysis
                </ServiceCard>

                <ServiceCard title="Insurance Solutions" img="img/insur_sol.png" href="/services#insurance">
                    Life, health, disability. Critical illness, travel, visitor insurance
                </ServiceCard>

                <ServiceCard title="Investment Guidance" img="img/investment_icon.png" href="/services#investment">
                    RRSP, TFSA, FHSA, RESP
                </ServiceCard>

            </div>

        </section>

        <section id="whywe" className="m-5 p-5 bg-white rounded-xl shadow-lg scroll-mt-24">
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Why Choose Us</h2>
            <div className="max-w-[1072px] mx-auto grid gap-6 sm:grid-cols-2 lg:grid-cols-4">

                <WhyWeCard title="Expertise & Professional Oversight">
                    Services are led by a <strong>Chartered Professional Accountant (CPA)</strong> and supported by a dedicated team,
                    ensuring professional oversight, accuracy, and compliance with applicable standards and regulations.
                </WhyWeCard>

                <WhyWeCard title="Comprehensive Accounting Services">
                    A broad range of accounting, tax, payroll, and advisory services are provided under one roof,
                    allowing for consistent support and a clear understanding of each client’s financial situation.
                </WhyWeCard>

                <WhyWeCard title="Trust, Integrity & Compliance">
                    Professional services are delivered in accordance with <strong>ethical and professional standards</strong>,
                    with a strong focus on confidentiality, transparency, and reliable financial reporting.
                </WhyWeCard>

                <WhyWeCard title="Practical Financial Guidance">
                    Beyond preparing reports and filings, services are designed to provide <strong>clear, practical guidance</strong>
                        that supports informed decision-making and long-term financial stability.
                </WhyWeCard>
            </div>
        </section>

        <section className="m-5 p-5 bg-white rounded-xl shadow-lg scroll-mt-24">
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Our location</h2>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2450.0609660078353!2d-106.6426241!3d52.115019499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4a39d94af626db8f%3A0x96d87a458ea6bb65!2sR%26Co.%20Chartered%20Professional%20Accountant!5e0!3m2!1sen!2sca!4v1770322685585!5m2!1sen!2sca"
                className="w-full h-[350px] border-0" allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">

            </iframe>


            <div id="contact" className="grid md:grid-cols-2 gap-6 items-start">

                <div className="w-full ">

                    <h2 className="text-3xl font-bold mb-4 text-gray-800 mt-5">Connect with us!</h2>

                    <p>
                        Whether you need help with filing, guidance, or have any questions, our team is here to support
                        you.
                        Share your details, and one of our experts will contact you to assist you through the process.
                    </p>

                    <div className="space-y-3 text-gray-700 mt-5">

                        <div className="flex items-center gap-3">
                            <img src="img/phone-call.png" className="w-6 h-6" alt="Phone Call"/>
                            <a href="tel:+13062217868" className="hover:text-[#2f855a] font-medium">
                                +1 (306) 221-7868
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <img src="img/phone-call.png" className="w-6 h-6" alt="Phone Call"/>
                            <a href="tel:+13062032082" className="hover:text-[#2f855a] font-medium">
                                +1 (306) 203-2082
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <img src="img/email.png" className="w-6 h-6" alt="Email"/>
                            <a href="mailto:info@rcotax.ca" className="hover:text-[#2f855a] font-medium">
                                info@rcotax.ca
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <img src="img/whatsapp.png" className="w-6 h-6" alt="WhatsApp"/>
                            <a href="https://wa.me/13062217868" target="_blank"
                               className="hover:text-[#2f855a] font-medium">
                                WhatsApp
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <img src="img/telegram.png" className="w-6 h-6" alt="Telegram"/>
                            <a href="https://t.me/R_and_Co_Accounting" target="_blank"
                               className="hover:text-[#2f855a] font-medium">
                                Telegram
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <img src="img/viber.png" className="w-6 h-6" alt="Viber"/>
                            <a href="viber://chat?number=%2B13062217868" target="_blank"
                               className="hover:text-[#2f855a] font-medium">
                                Viber
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <img src="img/google-maps.png" className="w-6 h-6" alt="Address"/>
                            <a href="https://www.google.com/maps/place/R%26Co.+Chartered+Professional+Accountant/@52.1150195,-106.645199,17z/data=!3m1!4b1!4m6!3m5!1s0x4a39d94af626db8f:0x96d87a458ea6bb65!8m2!3d52.1150195!4d-106.6426241!16s%2Fg%2F11k9k6w_xs?entry=ttu&g_ep=EgoyMDI2MDIwMy4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D"
                               target="_blank"
                               className="hover:text-[#2f855a] font-medium">
                                1145 8 St E, Saskatoon, SK S7H 0S3
                            </a>
                        </div>

                        <div className="flex items-center gap-3 font-medium">
                            <img src="img/working-hours.png" className="w-6 h-6" alt="Working hours"/>
                            Office Hours: Monday to Friday, 9am - 6pm (extended hours during tax season)
                        </div>

                    </div>

                </div>

                <div className="space-y-4 text-gray-700">

                    <MessageForm />

                </div>

            </div>
        </section>
    </>;
}